export const STREAMER_CONFIG = 'STREAMER_CONFIG'
export const FINAL_AMOUNT = 'FINAL_AMOUNT'
